<template>
  <div class="robot">
    <div v-if="!showServicePeopel">
      <div class="webHeader">
        <div v-if="allBanners && allBanners.length">
          <van-swipe :autoplay="3000" lazy-render class="headerImg">
            <van-swipe-item v-for="banners in allBanners" :key="banners.id">
              <div class="headerImgBlock" @click="toBanners(banners)">
                <!-- <van-image fit="cover" :src="banners.picture" class="headerImgCover" /> -->
                <!-- <div :style="{backgroundImage:banners.picture}" class="headerImgCover"></div> -->
                <img :src="banners.picture" class="headerImgCover" alt="" />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div v-else class="headerImgBlock">
          <img src="@/assets/images/headerImg.png" alt="" fit="cover" class="headerImgCover" />
        </div>
      </div>
      <div class="content">
        <div class="loading-style" v-if="isLoading">
          <van-loading type="spinner" vertical>{{
            $t('加载中...')
          }}</van-loading>
        </div>
        <div class="tabLine" v-else>
          <div class="tab" @click="toVisitors">
            <img src="@/assets/images/visitor.svg" alt="" class="tabImg" />
            <p class="tabText">{{ $t('访客邀约') }}</p>
          </div>
          <div class="tab" @click="toMeeting">
            <img src="@/assets/images/meetinginvite.svg" alt="" class="tabImg" />
            <p class="tabText">{{ $t('会议预约') }}</p>
          </div>
          <div class="tab" @click="toStation">
            <img src="@/assets/images/station.svg" alt="" class="tabImg" />
            <p class="tabText">{{ $t('工位预约') }}</p>
          </div>
        </div>
        <div class="schedule">
          <div class="scheduleHeader">
            <div class="scheduleHeaderLeft">
              <div class="scheduleHeaderTitle">
                <div :class="isRepresentative ? 'clickLeftButton' : 'notClickLeftButton'
                  " @click="choseRepresentative(true)">
                  {{ $t('待办') }}
                </div>
                <div :class="isRepresentative ? 'notClickLeftButton' : 'clickLeftButton'
                  " @click="choseRepresentative(false)">
                  {{ $t('日程') }}
                </div>
              </div>
            </div>
            <div v-if="isRepresentative">
              <div class="scheduleHeaderRight">
                <div class="scheduleHeaderRightBotton" @click="gotoRepresentative">
                  {{ $t('查看更多 >') }}
                </div>
              </div>
            </div>
            <div v-else>
              <div class="scheduleHeaderRight">
                <div class="scheduleHeaderRightBotton" @click="creatSchedule">
                  {{ $t('添加日程') }}
                </div>
                <div class="scheduleHeaderRightLine"></div>
                <div class="scheduleHeaderRightBotton" @click="searchSchedule">
                  {{ $t('查询日程') }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="isRepresentative">
            <div v-if="
              !isShowRepresentative &&
              representativeList &&
              representativeList.length
            " @click="showRepresentative" class="hideOverdueCard">
              <!-- <van-icon name="arrow-down" color="#666666" /> -->
              <div class="dropdownLine"></div>
              <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
              <div class="dropdownLine"></div>
            </div>
            <div v-if="
              isShowRepresentative &&
              representativeList &&
              representativeList.length
            ">
              <div v-for="(item, index) in representativeList" :key="item.id" :class="index + 1 == representativeList.length
                ? 'representativeListB'
                : 'representativeListD'
                ">
                <div @click="gotoRepresentativeList(item)" :class="index + 1 == representativeList.length
                  ? 'representativeListBBlock'
                  : 'representativeListDBlock'
                  ">
                  <div class="representativeListName">
                    {{ item.submitterName }}{{ $t(' 提交的 会议室预约申请') }}
                  </div>
                  <div class="representativeOther">
                    <img src="@/assets/images/meetingName.svg" alt="" class="overepresentativeImg" />
                    <div class="representativeName">{{ item.title }}</div>
                  </div>
                  <div class="representativeTime">
                    <img src="@/assets/images/overdueTime.svg" alt="" class="overepresentativeImg" />
                    <div class="representativeOtherTime">
                      {{ item.time }}
                    </div>
                  </div>
                  <div class="representativeOther">
                    <img src="@/assets/images/overdueAddress.svg" alt="" class="overepresentativeImg" />
                    <div class="representativeName">
                      {{ item.meetingRoomName }}
                    </div>
                  </div>
                  <div class="representativeOther">
                    <img src="@/assets/images/level.svg" alt="" class="overepresentativeImg" />
                    <div class="representativeName">
                      {{
                        item.meetingLevel == 1
                          ? $t('1星')
                          : item.meetingLevel == 2
                            ? $t('2星')
                            : item.meetingLevel == 3
                              ? $t('3星')
                              : $t('无')
                      }}
                    </div>
                  </div>
                </div>
                <div class="operationRe">
                  <div @click="onRefuseRe(item)" class="refuseButton" v-if="item.isMydone == 1">
                    {{ $t('拒绝') }}
                  </div>
                  <div @click="onOk(item)" class="okButton" v-if="item.isMydone == 1">
                    {{ $t('同意') }}
                  </div>
                  <div @click="onAllocation(item)" class="allocationBotton" v-if="item.isMydone == 2">
                    {{ $t('分配人员') }}
                  </div>
                  <div @click="onDone(item)" class="allocationBotton" v-if="item.isMydone == 3">
                    {{ $t('完成') }}
                  </div>
                  <div @click="onComment(item)" class="allocationBotton" v-if="item.isMydone == 4">
                    {{ $t('点评') }}
                  </div>
                </div>
              </div>
              <div class="hideOverdueLine" @click="hideRepresentative">
                <!-- <van-icon name="arrow-up" color="#666666" /> -->
                <div class="dropdownLine"></div>
                <img src="@/assets/images/dropdownup.svg" alt="" class="dropdownImg" />
                <div class="dropdownLine"></div>
              </div>
            </div>
            <div v-if="!representativeList || !representativeList.length" class="emptyStyle">
              <img src="@/assets/images/emptySchedule.png" alt="" fit="cover" class="emptyImg" />
              <div class="emptyText">{{ $t('暂无内容') }}</div>
            </div>
          </div>
          <div v-else>
            <div class="scheduleTopHeader">
              <div class="scheduleHeaderTitleOther">
                <div :class="isToday ? 'clickLeftText' : 'notClickLeftText'" @click="choseToday(1)">
                  {{ $t('当天日程') }}
                  <div v-if="isToday" class="scheduleHeaderTitleBottom"></div>
                </div>
                <div :class="isToday ? 'notClickLeftText' : 'clickLeftText'" @click="choseToday(7)">
                  {{ $t('7天日程') }}
                  <div v-if="!isToday" class="scheduleHeaderTitleBottom"></div>
                </div>
              </div>
            </div>
            <div class="scheduleTopHeaderLine"></div>
            <div v-if="!isShowOverdue && overdue && overdue.length" @click="showOverdua" class="hideOverdueCard">
              <!-- <van-icon name="arrow-down" color="#666666" /> -->
              <div class="dropdownLine"></div>
              <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
              <div class="dropdownLine"></div>
            </div>
            <div v-if="isShowOverdue && overdue && overdue.length" class="overdueLine">
              <div v-for="item in overdue" :key="item.id" class="overdueD" @click="gotoMeeting(item)">
                <div class="overdueName">{{ item.title }}</div>
                <div class="overdueOther" v-if="item.relationType === 'STATION'">
                  <img src="@/assets/images/overdueTime.svg" alt="" class="overdueImg" />
                  <div class="overdueOtherName" v-if="JSON.parse(item.stationConfig).mixMakeDay !== 'DAY'">
                    （{{ getTimeDate(item.beginTime) }}）{{
                      getTime(
                        JSON.parse(item.stationConfig).mixMakeDay,
                        item.beginTime
                      )
                    }}-{{
                      getTime(
                        JSON.parse(item.stationConfig).mixMakeDay,
                        item.endTime
                      )
                    }}
                  </div>
                  <div v-else class="overdueOtherName">
                    {{
                      getTime(
                        JSON.parse(item.stationConfig).mixMakeDay,
                        item.beginTime
                      )
                    }}{{ $t(' 至')
                    }}{{
                      getTime(
                        JSON.parse(item.stationConfig).mixMakeDay,
                        item.endTime
                      )
                    }}
                  </div>
                </div>
                <div class="overdueOther" v-else>
                  <img src="@/assets/images/overdueTime.svg" alt="" class="overdueImg" />
                  <div class="overdueOtherName">{{ item.time }}</div>
                </div>
                <div class="overdueOther">
                  <img src="@/assets/images/overdueAddress.svg" alt="" class="overdueImg" />
                  <div class="overdueOtherName">
                    {{ item.address ? item.address : $t('未填写') }}
                  </div>
                </div>
              </div>
              <div class="hideOverdueLine" @click="hideOverdua">
                <!-- <van-icon name="arrow-up" color="#666666" /> -->
                <div class="dropdownLine"></div>
                <img src="@/assets/images/dropdownup.svg" alt="" class="dropdownImg" />
                <div class="dropdownLine"></div>
              </div>
            </div>
            <div v-if="isToday">
              <div v-if="!isShowToday && orderList && orderList.length" @click="showToday" class="hideOverdueCard">
                <!-- <van-icon name="arrow-down" color="#666666" /> -->
                <div class="dropdownLine"></div>
                <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
                <div class="dropdownLine"></div>
              </div>
              <div v-if="isShowToday && orderList && orderList.length">
                <div v-for="(item, index) in orderList" :key="item.id" :class="index + 1 == orderList.length ? 'orderListB' : 'orderListD'
                  " @click="gotoMeeting(item)">
                  <div style="display: flex; width: 100%; align-items: flex-start">
                    <div class="orderListName">{{ item.title }}</div>
                    <div class="meetingStatus" :style="{
                      backgroundColor: item.agree
                        ? '#E1F7E9'
                        : item.agree === false
                          ? '#FFECEE'
                          : 'rgba(196,231,255,0.5)',
                    }" v-if="
                      (item.relationType === 'MEETING' ||
                        !item.relationType) &&
                      item.calendarStaff != user.id
                    ">
                      <div class="meetingStatusColor" :style="{
                        color: item.agree
                          ? '#0ECB81'
                          : item.agree === false
                            ? '#F6465D'
                            : '#3972FF',
                      }">
                        {{
                          item.agree
                            ? $t('已同意')
                            : item.agree === false
                              ? $t('已拒绝')
                              : $t('未处理')
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="orderListOther" v-if="item.relationType === 'STATION'">
                    <img src="@/assets/images/overdueTime.svg" alt="" class="orderListImg" />
                    <div class="orderListOtherName" v-if="JSON.parse(item.stationConfig).mixMakeDay !== 'DAY'">
                      {{ getYear(item.startTime) }}
                      {{
                        getTime(
                          JSON.parse(item.stationConfig).mixMakeDay,
                          item.beginTime
                        )
                      }}-{{
                        getTime(
                          JSON.parse(item.stationConfig).mixMakeDay,
                          item.endTime
                        )
                      }}
                    </div>
                    <div v-else class="orderListOtherName">
                      {{ getYear(item.beginTime) }}
                    </div>
                  </div>
                  <div class="orderListOther" v-else>
                    <img src="@/assets/images/overdueTime.svg" alt="" class="orderListImg" />
                    <div class="orderListOtherName">{{ item.time }}</div>
                  </div>
                  <div class="orderListOther">
                    <img src="@/assets/images/overdueAddress.svg" alt="" class="orderListImg" />
                    <div :class="!item.agree && item.agree != false
                      ? 'orderListOtherNameShort'
                      : 'orderListOtherName'
                      ">
                      {{ item.address ? item.address : $t('未填写') }}
                    </div>
                  </div>
                  <div v-if="item.relationType === 'STATION'" class="button_box">
                    <div v-if="item.signState === 'NOT_SING_IN'" style="display: flex">
                      <div v-if="
                        (!JSON.parse(item.stationConfig).isSign &&
                          !dayjs().isBefore(dayjs(item.beginTime))) ||
                        (JSON.parse(item.stationConfig).isSign &&
                          !dayjs().isBefore(dayjs(item.beginTime)) &&
                          canYouSignIn(item) !== 'SIGNIN')
                      " @click.stop="endEarly(item)" class="card_button_reserve">
                        {{ $t('提前结束') }}
                      </div>
                      <div v-if="
                        dayjs().isBefore(dayjs(item.beginTime)) ||
                        (JSON.parse(item.stationConfig).isSign &&
                          canYouSignIn(item) === 'SIGNIN')
                      " @click.stop="onStartCancel(item)" class="card_button_reserve">
                        {{ $t('取消预约') }}
                      </div>
                      <div v-if="
                        JSON.parse(item.stationConfig).isSign &&
                        JSON.parse(item.stationConfig).isH5Sign &&
                        canYouSignIn(item) === 'SIGNIN'
                      " @click.stop="onOK(item)" class="editDestine" style="margin-right: 12px">
                        {{ $t('签到') }}
                      </div>
                    </div>
                    <div v-if="item.signState === 'SING_IN'">
                      <div v-if="item.statusAttribute === 'IN_USE'" @click.stop="endEarly(item)"
                        class="card_button_reserve">
                        {{ $t('提前结束') }}
                      </div>
                    </div>
                  </div>
                  <!-- 自定义日程 -->
                  <div v-else-if="!item.relationType">
                    <div v-if="item.calendarStaff == user.id" class="operation">
                      <div @click.stop="onCancelCalendar(item)" class="cancelDestine">
                        {{ $t('取消日程') }}
                      </div>
                    </div>
                    <div v-else-if="item.calendarStaff != user.id" class="operation">
                      <div @click.stop="onRefuse(item, 0)" class="scheduleRejection"
                        v-if="!item.agree && item.agree != false">
                        {{ $t('拒绝') }}
                      </div>
                      <div @click.stop="checkRepeat(item)" class="scheduleDestine"
                        v-if="!item.agree && item.agree != false">
                        {{ $t('参加') }}
                      </div>
                    </div>
                  </div>
                  <div v-else-if="item.relationType != 'VISIT'">
                    <div v-if="
                      item.calendarStaff != user.id &&
                      !item?.agree &&
                      item?.agree != false
                    " class="operation">
                      <div v-if="item?.agree == undefined" @click.stop="onRefuse(item, 0)" class="rejectDestine">
                        <!-- 未处理 -->{{ $t('拒绝') }}
                      </div>
                      <div @click.stop="checkRepeat(item)" class="editDestine">
                        {{ $t('同意') }}
                      </div>
                    </div>
                    <div v-else-if="item.calendarStaff == user.id" class="operation">
                      <!-- 日程暂无时间开始时间 -->
                      <!-- <div @click.stop="onEarlyEnd(item)" class="cancelDestine" v-if="item.earlyEnd">
                  提前结束
                </div> -->
                      <div @click.stop="onCancel(item)" class="cancelDestine" v-if="!item.earlyEnd">
                        {{ $t('取消会议') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="hideOverdueLine" @click="hideToday">
                  <!-- <van-icon name="arrow-up" color="#666666" /> -->
                  <div class="dropdownLine"></div>
                  <img src="@/assets/images/dropdownup.svg" alt="" class="dropdownImg" />
                  <div class="dropdownLine"></div>
                </div>
              </div>
              <div v-if="!orderList || !orderList.length" class="emptyStyle">
                <img src="@/assets/images/emptySchedule.png" alt="" fit="cover" class="emptyImg" />
                <div class="emptyText">{{ $t('暂无内容') }}</div>
              </div>
            </div>
            <div v-if="!isToday">
              <div v-if="!isShowSeven && orderSevenList && orderSevenList.length" @click="showSeven"
                class="hideOverdueCard">
                <!-- <van-icon name="arrow-down" color="#666666" /> -->
                <div class="dropdownLine"></div>
                <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
                <div class="dropdownLine"></div>
              </div>
              <div v-if="isShowSeven && orderSevenList && orderSevenList.length">
                <div v-for="(lists, index) in orderSevenList" :key="lists.id" class="orderSevenListB">
                  <div class="orderListTite" :style="{ borderTopWidth: index == 0 ? 0 : 1 }">
                    <div class="orderListTiteLine">
                      <div class="orderListTitelName">{{ lists.date }}</div>
                      <div class="orderListTitelName">{{ lists.weekDay }}</div>
                      <div class="orderListTitelLine"></div>
                    </div>
                  </div>
                  <div v-for="(item, index) in lists.list" :key="item.id" class="orderListM" @click="gotoMeeting(item)"
                    :style="{
                      borderTopWidth: index == 0 ? 0 : 1,
                      paddingTop: index == 0 ? '4px' : 20,
                    }">
                    <div style="
                        display: flex;
                        width: 100%;
                        align-items: flex-start;
                      ">
                      <div class="orderListName">{{ item.title }}</div>
                      <div class="meetingStatus" :style="{
                        backgroundColor: item.agree
                          ? '#E1F7E9'
                          : item.agree === false
                            ? '#FFECEE'
                            : 'rgba(196,231,255,0.5)',
                      }" v-if="
                        (item.relationType === 'MEETING' ||
                          !item.relationType) &&
                        item.calendarStaff != user.id
                      ">
                        <div class="meetingStatusColor" :style="{
                          color: item.agree
                            ? '#0ECB81'
                            : item.agree === false
                              ? '#F6465D'
                              : '#3972FF',
                        }">
                          {{
                            item.agree
                              ? $t('已同意')
                              : item.agree === false
                                ? $t('已拒绝')
                                : $t('未处理')
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="orderListOther">
                      <img src="@/assets/images/overdueTime.svg" alt="" class="orderListImg" />
                      <div class="orderListOtherName">{{ item.time }}</div>
                    </div>
                    <div class="orderListOther">
                      <img src="@/assets/images/overdueAddress.svg" alt="" class="orderListImg" />
                      <div :class="!item.agree && item.agree != false
                        ? 'orderListOtherNameShort'
                        : 'orderListOtherName'
                        ">
                        {{ item.address ? item.address : $t('未填写') }}
                      </div>
                    </div>
                    <div v-if="item.relationType === 'STATION'" class="button_box">
                      <div v-if="item.signState === 'NOT_SING_IN'" style="display: flex">
                        <div v-if="
                          (!JSON.parse(item.stationConfig).isSign &&
                            !dayjs().isBefore(dayjs(item.beginTime))) ||
                          (JSON.parse(item.stationConfig).isSign &&
                            !dayjs().isBefore(dayjs(item.beginTime)) &&
                            canYouSignIn(item) !== 'SIGNIN')
                        " @click.stop="endEarly(item)" class="card_button_reserve">
                          {{ $t('提前结束') }}
                        </div>
                        <div v-if="
                          dayjs().isBefore(dayjs(item.beginTime)) ||
                          (JSON.parse(item.stationConfig).isSign &&
                            canYouSignIn(item) === 'SIGNIN')
                        " @click.stop="onStartCancel(item)" class="card_button_reserve">
                          {{ $t('取消预约') }}
                        </div>
                        <div v-if="
                          JSON.parse(item.stationConfig).isSign &&
                          JSON.parse(item.stationConfig).isH5Sign &&
                          canYouSignIn(item) === 'SIGNIN'
                        " @click.stop="onOK(item)" class="editDestine" style="margin-right: 12px">
                          {{ $t('签到') }}
                        </div>
                      </div>
                      <div v-if="item.signState === 'SING_IN'">
                        <div v-if="item.statusAttribute === 'IN_USE'" @click.stop="endEarly(item)"
                          class="card_button_reserve">
                          {{ $t('提前结束') }}
                        </div>
                      </div>
                    </div>
                    <!-- 自定义日程 -->
                    <div v-else-if="!item.relationType">
                      <div v-if="item.calendarStaff == user.id" class="operation">
                        <div @click.stop="onCancelCalendar(item)" class="cancelDestine">
                          {{ $t('取消日程') }}
                        </div>
                      </div>
                      <div v-else-if="item.calendarStaff != user.id" class="operation">
                        <div @click.stop="onRefuse(item, 0)" class="scheduleRejection" v-if="!item.agree">
                          {{ $t('拒绝') }}
                        </div>
                        <div @click.stop="checkRepeat(item)" class="scheduleDestine" v-if="!item.agree">
                          {{ $t('参加') }}
                        </div>
                      </div>
                    </div>
                    <div v-else-if="item.relationType != 'VISIT'">
                      <div v-if="
                        item.calendarStaff != user.id &&
                        !item?.agree &&
                        item?.agree != false
                      " class="operation">
                        <div v-if="item?.agree == undefined" @click.stop="onRefuse(item, 0)" class="rejectDestine">
                          <!-- 未处理 -->{{ $t('拒绝') }}
                        </div>
                        <div @click.stop="checkRepeat(item)" class="editDestine">
                          {{ $t('同意') }}
                        </div>
                      </div>
                      <div v-else-if="item.calendarStaff == user.id" class="operation">
                        <!-- <div @click.stop="onEarlyEnd(item)" class="cancelDestine" v-if="item.earlyEnd">
                    提前结束
                  </div> -->
                        <div @click.stop="onCancel(item)" class="cancelDestine" v-if="!item.earlyEnd">
                          {{ $t('取消会议') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="hideOverdueLine" @click="hideSeven">
                  <!-- <van-icon name="arrow-up" color="#666666" /> -->
                  <div class="dropdownLine"></div>
                  <img src="@/assets/images/dropdownup.svg" alt="" class="dropdownImg" />
                  <div class="dropdownLine"></div>
                </div>
              </div>
              <div v-if="!orderSevenList || !orderSevenList.length" class="emptyStyle">
                <img src="@/assets/images/emptySchedule.png" alt="" fit="cover" class="emptyImg" />
                <div class="emptyText">{{ $t('暂无内容') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bigDataCard">
          <!-- <div class="dataTitle">
          <div class="dataTitleC"></div>
          <div class="dataTitleText">大数据信息</div>
        </div> -->
          <div class="dataInfo">
            <div :class="hasWarn ? 'dataInfoThree' : 'dataInfoTwo'">
              <div class="dataNumber colorG">{{ hostInfo.online }}</div>
              <div class="dataNumberName">{{ $t('在线设备') }}</div>
            </div>
            <div class="hasLine"></div>
            <div :class="hasWarn ? 'dataInfoThree' : 'dataInfoTwo'" @click="showOffLine">
              <div class="dataNumber colorR">
                {{ hostInfo?.offline?.count }}
              </div>
              <div class="dataNumberName">{{ $t('离线设备') }}</div>
            </div>
            <div v-if="hasWarn" class="hasWarnStyle">
              <div class="hasLine"></div>
              <div class="dataInfoThree">
                <div class="dataNumber colorY">{{ hostInfo.aistrategy }}</div>
                <div class="dataNumberName">{{ $t('AI策略报警信息') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <van-empty description="暂无信息" v-else /> -->
    <TabBar v-if="sourceIsH5 && !showServicePeopel" />
    <van-popup v-model="offLine" position="bottom" safe-area-inset-bottom>
      <div class="offLineTitle">{{ $t('离线设备列表') }}</div>
      <div class="offLineD">
        <div v-if="offLineList && offLineList.length">
          <div v-for="item in offLineList" :key="item.id" class="offLineItem">
            <div class="offLineName">
              <div class="offLineNameDot"></div>
              <div class="offLineNameText">{{ item.name }}</div>
            </div>
            <div class="offLineTime">{{ item.lastModifiedTime }}</div>
          </div>
        </div>
        <div v-else class="emptyOffLine">
          <img src="@/assets/images/emptySchedule.png" alt="" fit="cover" class="emptyOffLineImg" />
          <div class="emptyText">{{ $t('暂无数据') }}</div>
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="showRefuse" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="ifAgree ? onRefuse(refuseData, 1) : clickeRefuse()" class="outsiderStyle" :cancelButtonText="$t('取消')"
      :confirmButtonText="$t('确认')" :beforeClose="checkRemark">
      <template #title>
        <div class="outsider-title">
          {{ ifAgree ? $t('同意参会') : $t('拒绝参会') }}
        </div>
      </template>
      <!-- <div class="refuse-box">
        <div>{{ifAgree ? '是否确认参加会议？' : '是否拒绝参加会议？'}}</div>
      </div> -->
      <div class="remark-box margin8">
        <van-field v-model="message" rows="2" autosize type="textarea" maxlength="50"
          :placeholder="ifAgree ? $t('请输入留言') : $t('请填写原因说明')" :required="!ifAgree" :error="!ifAgree && !message"
          size="14px" />
      </div>
    </van-dialog>
    <van-dialog v-model="showRepeat" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="onRefuse(refuseData, 1)" class="outsiderStyle" :cancelButtonText="$t('取消')"
      :confirmButtonText="$t('确认')">
      <template #title>
        <div class="repeat-title">{{ $t('同意参会') }}</div>
      </template>
      <div class="repeat-box">
        <div class="repeat-tip">
          {{
            $t(
              '本次会议时间段与您参与的以下会议存在时间重叠，是否确认继续参会？'
            )
          }}
        </div>
        <div :style="{
          paddingBottom: repeatList.length == 1 ? '1.07vw' : '2.13vw',
        }" class="repeat-info">
          <div v-for="item in repeatList" :key="item.appointmentId" class="repeat-info-box">
            <div>{{ item.appointmentTopic }}</div>
            <div>
              {{ dayjs(item.beginTime).format('HH:mm') }}-{{
                dayjs(item.endTime).format('HH:mm')
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="remark-box margin-repaet">
        <van-field v-model="message" rows="2" autosize type="textarea" maxlength="50" :placeholder="$t('请输入留言')"
          size="14px" />
      </div>
    </van-dialog>
    <van-dialog v-model="showCancel" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="clickeCancel" class="outsiderStyle" :cancelButtonText="$t('暂不')" :confirmButtonText="$t('确定')">
      <template #title>
        <div class="outsider-title">{{ $t('取消预订') }}</div>
      </template>
      <div class="cancel-box">
        <div class="first-cancel">
          {{ $t('时间：')
          }}{{ dayjs(cancelData.beginTime).format('YYYY/MM/DD') }}
          {{ dayjs(cancelData.beginTime).format('HH:mm') }}-
          {{ dayjs(cancelData.endTime).format('HH:mm') }}
        </div>
        <div>{{ $t('地点：') }}{{ cancelData.address || $t('线上') }}</div>
      </div>
    </van-dialog>
    <van-dialog v-model="showEarlyEnd" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="clickeEarlyEnd" class="outsiderStyle" :cancelButtonText="$t('暂不')" :confirmButtonText="$t('确定')">
      <template #title>
        <div class="outsider-title">{{ $t('提前结束') }}</div>
      </template>
      <div class="cancel-box">
        <div class="first-cancel">
          {{ $t('时间：')
          }}{{ dayjs(earlyEndData.beginTime).format('YYYY/MM/DD') }}
          {{ dayjs(earlyEndData.beginTime).format('HH:mm') }}-
          {{ dayjs(earlyEndData.endTime).format('HH:mm') }}
        </div>
        <div>{{ $t('地点：') }}{{ earlyEndData.address || $t('线上') }}</div>
      </div>
    </van-dialog>
    <van-popup v-model="showOk" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickOkClose()">X</div>
          <div class="popupTitle">{{ $t('同意审批') }}</div>
        </div>
        <div class="popupBlock" @click="showArea = true">
          <div class="popupOk">
            <div class="commentStyle">{{ $t('预选会议室：') }}</div>
            <div class="okTextStyle">{{ meetingRoomName }}</div>
          </div>
          <img src="@/assets/images/dropdown.png" alt="" class="dropdownImgOther" />
        </div>
        <div class="popupOkOther">
          <div class="commentStyle" style="margin-bottom: 10px">
            {{ $t('会议等级：') }}
          </div>
          <van-radio-group v-model="meetingChoseLevel" direction="horizontal">
            <van-radio :name="0">{{ $t('无') }}</van-radio>
            <van-radio :name="1">{{ $t('1星') }}</van-radio>
            <van-radio :name="2">{{ $t('2星') }}</van-radio>
            <van-radio :name="3">{{ $t('3星') }}</van-radio>
          </van-radio-group>
        </div>
        <div class="bookBoxOk">
          <van-button round block native-type="submit" :class="meetingRoomName &&
            (meetingChoseLevel == 0 ||
              meetingChoseLevel == 1 ||
              meetingChoseLevel == 2 ||
              meetingChoseLevel == 3)
            ? 'blue-btn'
            : 'grey-btn'
            " @click="doOk()" :disabled="isUseDoOk">{{ $t('完成') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showRefuseRe" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickRefuseClose()">X</div>
          <div class="popupTitle">{{ $t('拒绝审批') }}</div>
        </div>
        <van-field v-model="refuseMessage" rows="7" autosize type="textarea" :placeholder="$t('请输入拒绝原因')" size="14px" />
        <div class="bookBox">
          <van-button round block type="danger" native-type="submit" class="danger-btn" @click="doRefuse()" :disable="isUseRefuse">{{ $t('拒绝')
          }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showAllocation" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickAllocationClose()">X</div>
          <div class="popupTitle">{{ $t('分配会务服务人') }}</div>
        </div>
        <div>
          <div class="popupBlock" @click="cilkcshowServicePeopel()">
            <div class="popupOk">
              <div class="commentStyle">{{ $t('服务人：') }}</div>
              <div :class="servicePeopelName ? 'okTextStyle' : 'okTextGreyStyle'">
                {{ servicePeopelName ? servicePeopelName : $t('请选择') }}
              </div>
            </div>
            <img src="@/assets/images/dropdown.png" alt="" class="dropdownImgOther" />
          </div>
        </div>
        <div class="bookBoxAllocation">
          <van-button round block native-type="submit" :class="servicePeopelName ? 'blue-btn' : 'grey-btn'"
            @click="doAllocation()" :disabled="isUseAllocation">{{ $t('分配') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showDone" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickDoneClose()">X</div>
          <div class="popupTitle">{{ $t('会务服务') }}</div>
        </div>
        <div class="popupText">{{ $t('会务服务工作是否完成？') }}</div>
        <div class="bookBox">
          <van-button round block native-type="submit" class="blue-btn" @click="doDone()" :disabled="isUseDone">{{ $t('完成') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showComment" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickCommentClose()">X</div>
          <div class="popupTitle">{{ $t('会务点评') }}</div>
        </div>
        <div class="popupComment">
          <div class="commentStyle">{{ $t('会务点评：') }}</div>
          <van-rate v-model="commentValue" :count="5" color="#FAAD14" />
        </div>
        <div class="bookBox">
          <van-button round block native-type="submit" :class="commentValue >= 1 ? 'blue-btn' : 'grey-btn'"
            @click="doComment()" :disabled="isUseComment">{{ $t('完成') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="isCancel" position="bottom"
      :style="{ height: '100%', backgroundColor: 'rgba(255, 255, 255, 0)' }">
      <div class="isCancelMask">
        <van-loading type="spinner" vertical>{{ $t('加载中...') }}</van-loading>
      </div>
    </van-popup>
    <van-popup v-model="showArea" position="bottom" safe-area-inset-bottom>
      <div>
        <div class="timeListTitle">{{ $t('选择会议室') }}</div>
        <van-checkbox-group v-model="areaResult" class="timeList" max="1">
          <div style="position: absolute; top: 0; height: 318px">
            <van-checkbox :name="index" class="timeListCard" icon-size="21px" v-for="(item, index) in areaList"
              :key="index">
              <div class="timeListRange">{{ item.name }}</div>
            </van-checkbox>
          </div>
        </van-checkbox-group>
      </div>
      <div class="bookBox">
        <van-button round block type="info" native-type="submit" class="blue-btn" @click="toMeetingInform">{{ $t('确定')
        }}</van-button>
      </div>
    </van-popup>
    <van-dialog v-model="showToast" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="IsDoOk()" class="outsiderStyle" :cancelButtonText="$t('取消')" :confirmButtonText="$t('确认')">
      <template #title>
        <div class="outsider-title">
          {{ '该会议室没有会务服务，是否要更换' }}
        </div>
      </template>
    </van-dialog>
    <Address :userList="userList" v-if="showServicePeopel" @back="toInform" @confirm="confirmSearch"
      :selectedList="[]" />
  </div>
</template>
<script>
import {
  getRole,
  queryOffline,
  queryAllMettingList,
  dateOverlap,
  saveMeetingMessage,
  refuseMeeting,
  updateAppointmentStatus,
  deleteAppointment,
  cancelMeeting,
  cancelOnlineMeeting,
  earlyTermination,
  queryBanners,
  queryCalendar,
  queryCalendarStation,
  cancelCalendarById,
  addButtonApi,
  getCompanyInfo,
  getUserList,
  getMeetingRoomByArea,
  h5MeetingServiceRecord,
  processingData,
  // cancelProcess,
  assignPersonnel,
  // editorById,
  // revokeProcess,
  serviceComplete,
  submitterGrade,
  getMeetingRoomById,
} from '@/services/api'
import TabBar from '@/components/tabBar'
import Vue from 'vue'
import dayjs from 'dayjs'
import {
  Empty,
  Icon,
  Dialog,
  Field,
  Toast,
  Swipe,
  SwipeItem,
  Loading,
  Popup,
  Tab,
  Tabs,
  Rate,
} from 'vant'
import { Image as VanImage } from 'vant'
import Address from '../../representative/address.vue'
import moment from 'moment'
import './font.css'

Vue.use(Empty)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(VanImage)
Vue.use(Loading)
Vue.use(Popup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Rate)

export default {
  name: 'Robot',
  components: {
    TabBar,
    Address,
  },
  data() {
    return {
      maxHeight: '100%',
      user: {},
      showRobot: false,
      sourceIsH5: true,
      hostInfo: {},
      newDay: 1,
      hasWarn: false,
      offLine: false,
      offLineList: [],
      isRepresentative: true,
      isToday: true,
      isCancel: false,
      overdue: [],
      orderList: [],
      representativeList: [],
      isShowOverdue: false,
      isShowToday: true,
      isShowSeven: true,
      repeatList: [],
      showCancel: false,
      cancelData: {},
      showEarlyEnd: false,
      earlyEndData: {},
      refuseData: {},
      showRepeat: false,
      showRefuse: false,
      ifAgree: false,
      message: '',
      stationConfig: {},
      orderSevenList: [],
      weekday: [
        { key: 0, value: this.$t('周日') },
        { key: 1, value: this.$t('周一') },
        { key: 2, value: this.$t('周二') },
        { key: 3, value: this.$t('周三') },
        { key: 4, value: this.$t('周四') },
        { key: 5, value: this.$t('周五') },
        { key: 6, value: this.$t('周六') },
      ],
      menuPermissions: [], // 用户权限菜单
      allBanners: [], //轮播列表
      isLoading: false,
      isShowRepresentative: true,
      showArea: false,
      areaList: [],
      areaid: '',
      meetingRoomName: '',
      areaResult: [],
      createdList: [],
      expireList: [],
      inviteFinished: false,
      processedLoading: false,
      createdLoading: false,
      expireLoading: false,
      choseData: {},
      showRefuseRe: false,
      isUseRefuse: false,
      showOk: false,
      isUseDoOk: false,
      showAllocation: false,
      isUseAllocation: false,
      showComment: false,
      isUseComment: false,
      showDone: false,
      isUseDone: false,
      ifAgree: false,
      refuseMessage: '',
      commentValue: 0,
      meetingChoseLevel: 0,
      servicePeopelName: '',
      servicePeopelId: '',
      servicePersonnerlDpt: '',
      showServicePeopel: false,
      userList: [],
      showToast: false,
    }
  },
  methods: {
    async getUsers(companyId) {
      try {
        const res = await getUserList({ companyId })
        let arr = [...res]
        this.userList = arr
      } catch (error) {
        console.log(error)
      }
    },
    async getAreaId(developerId) {
      try {
        const res = await getMeetingRoomByArea({
          developerId,
        })
        let tmpArr = [...res]
        tmpArr.forEach((item, idx) => {
          if (item.state === 'nouse') {
            // tmpArr.splice(idx, 1)
          }
        })
        tmpArr.forEach((item) => {
          if (item.state != 'nouse') {
            this.areaList.push({ name: item.name, id: item.id })
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async onOK(value) {
      const data = await updateAppointmentStatus({
        stationSignId: value.visitId,
        state: 'YES',
        userId: this.user.id,
      })
      if (data.code === 200) {
        this.getMettingList(1)
        Toast(this.$t('签到成功'))
      } else {
        Toast(this.$t('此时间段不可签到！'))
      }
    },
    // handleResize() {
    //   this.maxHeight = (window.innerHeight - 68) + 'px';
    // },
    getYear(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    getTimeDate(value) {
      return moment(value).calendar(null, {
        sameDay: this.$t('[今天]'),
        nextDay: this.$t('[明天]'),
        nextWeek: this.$t('[下周]'),
        lastDay: this.$t('[昨天]'),
        lastWeek: this.$t('[上周]'),
        sameElse: this.$t('[一周以后]'),
      })
    },
    async endEarly(value) {
      const res = await earlyTermination({
        companyId: this.user.companyId,
        userId: this.user.id,
        stationSignId: value.visitId,
      })
      if (res.code === 200) {
        this.getMettingList(1)
        Toast(`${res.msg}`)
      } else {
        Toast(`${res.msg}`)
      }
    },

    canYouSignIn(value) {
      const stationConfig = value.stationConfig
        ? JSON.parse(value.stationConfig)
        : {}
      //当预约时间段是天
      const createdTimeToDay = moment().isSame(moment(value.createdTime), 'day') //创建时间是否为今天
      const startTimeToDay = moment().isSame(moment(value.beginTime), 'day') //预约时间是否为今天
      // if (stationConfig.mixMakeDay == 'DAY') {
      //   const isMorning = dayjs().hour() < 12 //当前时间是否为上午
      //   const createdTimeIsMorning = dayjs(value.createdTime).hour() < 12 //创建时间是否为上午
      //   const signDate =
      //     dayjs() <
      //     dayjs(value.createdTime).hour(dayjs(value.createdTime).hour() + 2) //当天下午预约，可签到时间为创建时间后两小时之内，当前时间是否处于可签到时间范围
      //   //非当天预约的情况下，签到截止的时间为12点
      //   if (!createdTimeToDay && startTimeToDay && isMorning) {
      //     return 'SIGNIN'
      //   }
      //   //当天上午预约。签到截止时间为12点
      //   if (
      //     createdTimeToDay &&
      //     startTimeToDay &&
      //     createdTimeIsMorning &&
      //     isMorning
      //   ) {
      //     return 'SIGNIN'
      //   }
      //   //当天下午预约，签到时间为创建时间后两个小时以内
      //   if (
      //     createdTimeToDay &&
      //     startTimeToDay &&
      //     !createdTimeIsMorning &&
      //     signDate
      //   ) {
      //     return 'SIGNIN'
      //   }
      //   return 'NOT_SIGNIN'
      // }

      //当预约时间段是半天
      // if (stationConfig.mixMakeDay == 'HALF_A_DAY') {
      //   const beforeNine =
      //     dayjs(value.createdTime) < dayjs().hour(9).minute(0).second(0) //创建时间是否在当天九点之前
      //   const beforeThirteen =
      //     dayjs().hour(13).minute(0).second(0) > dayjs(value.createdTime) &&
      //     dayjs(value.createdTime) > dayjs().hour(12).minute(0).second(0) //创建时间是否在当天的12点后13点前
      //   const afternine =
      //     dayjs(value.createdTime) >= dayjs().hour(9).minute(0).second(0) &&
      //     dayjs(value.endTime).hour() === 12 //当天九点之后预约的上午
      //   const afterThirteen =
      //     dayjs(value.createdTime) >= dayjs().hour(13).minute(0).second(0) &&
      //     dayjs(value.endTime).hour() === 23 //当天十三点之后预约的下午
      //   //判断是否开启了为签到释放，开启了则按特殊规则处理
      //   if (stationConfig.isRelease) {
      //     //当天上午九点钟之前预约，签到范围在九点加配置的分钟
      //     if (
      //       beforeNine &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs().hour(9).minute(stationConfig.releaseTime).second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     //下午十三点前预约，签到范围在十三点点加配置的分钟
      //     if (
      //       beforeThirteen &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs().hour(13).minute(stationConfig.releaseTime).second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     //上午九点钟之后预约上午，签到范围在创建时间加配置的分钟
      //     if (
      //       afternine &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs(value.createdTime)
      //           .minute(
      //             dayjs(value.createdTime).minute() +
      //               (stationConfig.releaseTime - 0)
      //           )
      //           .second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     //上午九点钟之后预约上午，签到范围在创建时间加配置的分钟
      //     if (
      //       afterThirteen &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs(value.createdTime)
      //           .minute(
      //             dayjs(value.createdTime).minute() +
      //               (stationConfig.releaseTime - 0)
      //           )
      //           .second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     return 'NOT_SIGNIN'
      //     //未开启则开始到结束时间都可以签到
      //   } else {
      //     if (
      //       dayjs() >= dayjs(value.beginTime) &&
      //       dayjs() < dayjs(value.endTime)
      //     ) {
      //       console.log(98776)
      //       return 'SIGNIN'
      //     }
      //     return 'NOT_SIGNIN'
      //   }
      // }

      //当预约时间段为小时/半小时
      if (
        stationConfig.mixMakeDay == 'HALF_A_HOUR' ||
        stationConfig.mixMakeDay == 'HOURS' ||
        stationConfig.mixMakeDay == 'CUSTOM_TIME' ||
        stationConfig.mixMakeDay == 'DAY'
      ) {
        const beforeCreatedTime =
          dayjs(value.createdTime) < dayjs(value.beginTime) //创建时间在预约时间段之前
        const afterTime = dayjs(value.createdTime) >= dayjs(value.beginTime) //创建时间在预约时间段之前
        if (stationConfig.isRelease) {
          if (
            beforeCreatedTime &&
            startTimeToDay &&
            dayjs() >= dayjs(value.beginTime) &&
            dayjs(value.beginTime)
              .minute(
                dayjs(value.beginTime).minute() +
                (stationConfig?.releaseTime ?? 0 - 0)
              )
              .second(0) > dayjs()
          ) {
            return 'SIGNIN'
          }
          if (
            afterTime &&
            startTimeToDay &&
            dayjs() <
            dayjs(value.createdTime)
              .minute(
                dayjs(value.createdTime).minute() +
                (stationConfig?.releaseTime ?? 0 - 0)
              )
              .second(0)
          ) {
            return 'SIGNIN'
          }
          return 'NOT_SIGNIN'
        } else {
          if (
            dayjs() >= dayjs(value.beginTime) &&
            dayjs() < dayjs(value.endTime)
          ) {
            return 'SIGNIN'
          }
          return 'NOT_SIGNIN'
        }
      }
    },
    async onStartCancel(value) {
      const data = await updateAppointmentStatus({
        stationSignId: value.visitId,
        state: 'NO',
        userId: this.user.id,
      })
      if (data.code === 200) {
        this.getMettingList(1)
        Toast(this.$t('取消成功！'))
      } else {
        Toast(this.$t('此时间段不可取消预约！'))
      }
    },
    clickeCancel() {
      this.showCancel = false
      this.isCancel = true
      if (!dayjs().isBefore(dayjs(this.cancelData.beginTime))) {
        Toast(this.$t('本会议已开始，不可取消，请刷新获取最新状态！'))
        return
      }
      if (
        this.cancelData?.address &&
        this.cancelData?.address != this.$t('线上会议')
      ) {
        cancelMeeting(this.cancelData.relationId).then(() => {
          //取消成功
          Toast(this.$t('会议已取消！'))
          this.getMettingList(this.newDay)
        })
      } else {
        cancelOnlineMeeting(this.cancelData.relationId).then(() => {
          Toast(this.$t('会议已取消！'))
          this.getMettingList(this.newDay)
        })
      }
    },
    onCancel(data) {
      this.cancelData = data
      this.showCancel = true
    },
    async onCancelCalendar(data) {
      if (dayjs(data?.calendarEndTime).isAfter(dayjs())) {
        await cancelCalendarById({ id: data.id, staffId: this.user.id })
        Toast(this.$t('日程已取消！'))
      } else {
        Toast(this.$t('日程已结束！无需取消'))
      }
      this.getMettingList(this.newDay)
    },
    clickeEarlyEnd() {
      this.showEarlyEnd = false
      this.isCancel = true
      if (this.earlyEndData) {
        deleteAppointment(this.earlyEndData.relationId).then(() => {
          //取消成功
          Toast(this.$t('会议已提前结束！'))
          this.getMettingList(this.newDay)
        })
      }
    },
    onEarlyEnd(data) {
      this.earlyEndData = data
      this.showEarlyEnd = true
    },
    toBanners(data) {
      this.$router.push(`/banners/?id=${data.id}`)
    },
    toVisitors() {
      // this.$store.state.visitorState = 'pre'
      if (!this.menuPermissions.find((v) => v.path === '/robotFrontDesk')) {
        Toast(this.$t('未开通该功能，请联系管理员'))
        return
      }
      this.$router.push('/newInvitation')
    },
    toMeeting() {
      if (!this.menuPermissions.find((v) => v.path === '/meetingRoom')) {
        Toast(this.$t('未开通该功能，请联系管理员'))
        return
      }
      this.$router.push('/meeting')
    },
    toStation() {
      if (
        !this.menuPermissions.find((v) => v.path === '/workStationReservation')
      ) {
        Toast(this.$t('未开通该功能，请联系管理员'))
        return
      }
      this.$router.push('/station')
    },
    async getPermissions(companyId) {
      let companyCode = JSON.parse(localStorage.getItem('companyCode')).code
        ? JSON.parse(localStorage.getItem('companyCode')).code
        : JSON.parse(localStorage.getItem('cCode')).code
      try {
        let companyMsg = await getCompanyInfo(companyCode)
        console.log(companyMsg)

        if (companyMsg.corpid) {
          localStorage.setItem('isVideoconferencing', '3')
        } else if (companyMsg.qwAppId) {
          localStorage.setItem('isVideoconferencing', '2')
        } else {
          let oaInfo = await addButtonApi(companyId)
          if (
            oaInfo &&
            Object.values(oaInfo).includes('TENCENT_VIDEO_CONFERENCE')
          ) {
            localStorage.setItem('isVideoconferencing', 1)
          } else {
            localStorage.setItem('isVideoconferencing', '5')
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getOffline(developerId) {
      try {
        const res = await queryOffline(developerId)
        this.hostInfo = res
        if (res.aistrategy > 0) {
          this.hasWarn = true
        } else {
          this.hasWarn = false
        }
        res.offline.context.map((item) => {
          if (item.lastModifiedTime) {
            let dateArr = item.lastModifiedTime.split(' ')
            let timeArr = dateArr[1].split(':')
            let newTime = dateArr[0] + '  ' + timeArr[0] + ':' + timeArr[1]
            item.lastModifiedTime = newTime
          }
        })
        this.offLineList = res.offline.context
      } catch (error) {
        console.log(error)
      }
    },
    async getBanners(companyId) {
      let data = {
        page: 1,
        pageSize: 500,
        companyId: companyId,
        h5PositionType: 1,
        displayTerminal: 'H5',
        shelves: 1,
      }
      try {
        queryBanners(data).then((res) => {
          this.allBanners = res.results
        })
      } catch (error) {
        console.log(error)
      }
    },
    getWeekName(week) {
      switch (week) {
        case '1':
          return this.$t('周一')
          break
        case '2':
          return this.$t('周二')
          break
        case '3':
          return this.$t('周三')
          break
        case '4':
          return this.$t('周四')
          break
        case '5':
          return this.$t('周五')
          break
        case '6':
          return this.$t('周六')
          break
        case '7':
          return this.$t('周日')
          break
      }
    },
    async geth5MeetingServiceRecord() {
      let params = {}
      params['tabState'] = 'PENDING'
      params['companyId'] = parseInt(this.user.companyId)
      params['staffId'] = this.user.id
      params['page'] = 1
      params['pageSize'] = 3
      try {
        let newRes = await h5MeetingServiceRecord(params)
        newRes?.results?.forEach((item) => {
          let time = ''
          if (
            item.meetingType &&
            item.meetingType == 'WEEKLY' &&
            item.type != 'MEETING_SERVICE'
          ) {
            let day1 = dayjs(item.meetingStartTime.split(' ')[0]).format(
              'YYYY.MM.DD'
            )
            let day2 = dayjs(item.weeklyEndTime).format('YYYY.MM.DD')
            let start = item.meetingStartTime.split(' ')[1]
            let end = item.meetingEndTime.split(' ')[1]
            let startTime = start?.split(':')[0] + ':' + start?.split(':')[1]
            let endTime = end?.split(':')[0] + ':' + end?.split(':')[1]
            let timeLine = day1 + '-' + day2 + ' ' + startTime + '-' + endTime
            let repeatDayOfWeek = item.repeatDayOfWeekString?.split(',') || []
            let timeWeek = ''
            repeatDayOfWeek?.map((v, index) => {
              timeWeek =
                timeWeek +
                this.getWeekName(v) +
                (index != repeatDayOfWeek.length - 1 ? '/' : '')
            })
            time = timeLine + this.$t('（每') + timeWeek + '）'
          } else {
            let day = dayjs(item.meetingStartTime.split(' ')[0]).format(
              'YYYY.MM.DD'
            )
            let start = item.meetingStartTime.split(' ')[1]
            let end = item.meetingEndTime.split(' ')[1]
            let startTime = start?.split(':')[0] + ':' + start?.split(':')[1]
            let endTime = end?.split(':')[0] + ':' + end?.split(':')[1]
            time = day + ' ' + startTime + '-' + endTime
          }
          item.time = time
          if (item.type == 'MEETING_SERVICE') {
            if (item.state == 'PENDING') {
              item.isMydone = 2
            } else if (item.state == 'ASSIGN') {
              item.isMydone = 3
            } else if (item.state == 'GRADE') {
              item.isMydone = 4
            }
          } else {
            if (item.state == 'PENDING') {
              item.isMydone = 1
            }
          }
        })
        this.representativeList = newRes?.results || []
      } catch (error) {
        console.log(error)
      }
    },
    async getMettingList(day) {
      let params = {}
      let overArr = []
      let orderArr = []
      this.newDay = day
      if (day == 1) {
        params['developerId'] = this.user.companyId
        params['companyId'] = this.user.companyId
        params['staffId'] = this.user.id
        params['beginTime'] = dayjs().format('YYYY-MM-DD 00:00:00')
        params['endTime'] = dayjs().format('YYYY-MM-DD 23:59:59')
        params['pageNum'] = 1
        params['pageSize'] = 10000
      } else {
        params['developerId'] = this.user.companyId
        params['companyId'] = this.user.companyId
        params['staffId'] = this.user.id
        params['beginTime'] = dayjs().format('YYYY-MM-DD 00:00:00')
        params['endTime'] = dayjs().add(6, 'day').format('YYYY-MM-DD 23:59:59')
        params['pageNum'] = 1
        params['pageSize'] = 10000
      }
      try {
        // const res1 = await queryAllMettingList(params)
        let newRes = await queryCalendar(params)
        let res = []
        newRes?.results?.forEach((item) => {
          res.push({
            title: item?.calendarTopic,
            beginTime: item?.calendarStartTime,
            endTime: item?.calendarEndTime,
            address: item?.calendarAddress,
            type: item?.relationType,
            calendarStaff: item?.calendarStaff,
            ...item,
          })
        })

        // 合并工位的数据
        let newResStation = await queryCalendarStation(params)
        newResStation = newResStation.map((item) => ({
          relationType: 'STATION',
          relationId: item.visitId,
          ...item,
        }))
        res = res.concat(newResStation || [])
        res = res.sort(
          (a, b) => dayjs(a.beginTime).valueOf() - dayjs(b.endTime).valueOf()
        )

        res.map((item) => {
          let startArr = item.beginTime.split(' ')[1].split(':')
          let endArr = item.endTime.split(' ')[1].split(':')
          let start = startArr[0] + ':' + startArr[1]
          let end = endArr[0] + ':' + endArr[1]
          item.time = start + '-' + end
          item.day = item.beginTime.split(' ')[0]
          item.earlyEnd = item.actualStartTime
            ? true
            : dayjs().isBefore(dayjs(item.beginTime))
              ? false
              : true
          if (
            item.actualEndTime ||
            dayjs().isAfter(dayjs(item.endTime)) ||
            (item.statusAttribute && item.statusAttribute === 'FINISHED')
          ) {
            // 过期或 工位预约已签到，需要进行隐藏
            overArr.push(item)
          } else {
            orderArr.push(item)
          }
        })
        this.overdue = overArr
        if (day == 1) {
          this.orderList = orderArr
          this.orderSevenList = []
        } else {
          this.orderList = []
          let sevenDay = []
          orderArr.forEach((item) => {
            let index = sevenDay.findIndex((data) => {
              return item.day === data.day
            })
            if (index > -1) {
              sevenDay[index].list.push(item)
            } else {
              let date = item.day.split('-')[1] + '-' + item.day.split('-')[2]
              this.weekday.map((week) => {
                if (dayjs(item.day).day() == week.key) {
                  if (
                    dayjs(item.day).isSame(dayjs(dayjs().format('YYYY-MM-DD')))
                  ) {
                    sevenDay.push({
                      date: this.$t('今天'),
                      day: item.day,
                      weekDay: '',
                      list: [item],
                      id: item.id,
                    })
                  } else {
                    if (
                      dayjs(item.day).isAfter(
                        dayjs().endOf('week').add(1, 'day')
                      )
                    ) {
                      sevenDay.push({
                        date: date,
                        day: item.day,
                        weekDay: this.$t('下') + week.value,
                        list: [item],
                        id: item.id,
                      })
                    } else {
                      sevenDay.push({
                        date: date,
                        day: item.day,
                        weekDay: week.value,
                        list: [item],
                        id: item.id,
                      })
                    }
                  }
                }
              })
            }
          })
          this.orderSevenList = sevenDay
        }
      } catch (error) {
        console.log(error)
      }
    },
    showOffLine() {
      this.offLine = true
    },
    hideOffLine() {
      this.offLine = false
    },
    choseRepresentative(flag) {
      this.isRepresentative = flag
    },
    choseToday(day) {
      this.isShowOverdue = false
      if (day == 1) {
        this.isToday = true
        this.getMettingList(1)
      } else {
        this.isToday = false
        this.getMettingList(7)
      }
    },
    ExtensionOfTime(value, releaseTime) {
      const event = new Date(value)
      const min = event.getMinutes()
      return event.setMinutes(min + (releaseTime - 0))
    },
    searchSchedule() {
      this.$router.push('/searchSchedule')
    },
    gotoRepresentative() {
      this.$router.push('/representative')
    },
    creatSchedule() {
      this.$router.push('/createSchedule')
    },
    showOverdua() {
      this.isShowOverdue = true
    },
    showToday() {
      this.isShowToday = true
    },
    showSeven() {
      this.isShowSeven = true
    },
    showRepresentative() {
      this.isShowRepresentative = true
    },
    hideOverdua() {
      this.isShowOverdue = false
    },
    hideToday() {
      this.isShowToday = false
    },
    hideSeven() {
      this.isShowSeven = false
    },
    hideRepresentative() {
      this.isShowRepresentative = false
    },
    gotoRepresentativeList(data) {
      this.$router.push({
        name: 'ApproveInforRead',
        query: {
          appointmentId: data.id,
        },
      })
    },
    gotoMeeting(data) {
      if (data.relationType == 'STATION') {
        this.$router.push({
          name: 'StationInfo',
          query: {
            stationId: data.relationId,
          },
        })
      } else if (data.relationType == 'VISIT') {
        this.$router.push(`/visitorInfo/${data.relationId}`)
      } else if (!data.relationType) {
        // 自定义日程没有type
        this.$router.push(`/scheduleInfo/?id=${data.id}`)
      } else {
        this.$router.push({
          name: 'MettingInforRead',
          query: {
            appointmentId: data.relationId,
          },
        })
      }
    },
    async checkRepeat(data) {
      // 自定义日程，无留言功能
      if (!data.relationType) {
        this.onRefuse(data, 1)
        return
      }

      const res = await dateOverlap({
        staffIds: this.user.id,
        beginTime: data.beginTime,
        endTime: data.endTime,
      })
      if (res.length) {
        let arr = res[0]?.dateOverlaps.filter(
          (item) => item.appointmentId != data.relationId
        )
        if (arr.length) {
          this.repeatList = arr
          this.refuseData = data
          this.showRepeat = true
        } else {
          this.ifAgree = true
          this.refuseData = data
          this.showRefuse = true
        }
      } else {
        this.ifAgree = true
        this.refuseData = data
        this.showRefuse = true
      }
    },
    getTime(mixMakeDay, value) {
      if (mixMakeDay !== 'DAY') {
        return moment(value).format('HH:mm')
      }
      return moment(value).format('YYYY-MM-DD')
    },
    async onRefuse(data, flag) {
      let staffId = this.user.id
      let value = {
        appointmentRecordId: data.relationId,
        staffId,
        opinion: flag ? true : false,
      }

      // 如果是自定义日程，需要添加日程id。日程是通称，没有单独的type
      if (!data.relationType) {
        value.calendarId = data.id
      }

      if (!data.relationType) {
        refuseMeeting(value).then(async (res) => {
          Toast(
            this.$t('日程已{slot1}！', {
              slot1: value.opinion ? this.$t('确认') : this.$t('拒绝'),
            })
          )
          this.getMettingList(this.newDay)
          this.showRepeat = false
          this.message = ''
        })
        return
      }

      if (!flag) {
        this.ifAgree = false
        this.refuseData = data
        this.showRefuse = true
      } else {
        if (this.message) {
          const parms = {
            staffId,
            remark: this.message,
            meetingId: this.refuseData.relationId,
          }
          await saveMeetingMessage(parms)
        }
        refuseMeeting(value).then(async (res) => {
          Toast(
            this.$t('会议已{slot1}！', {
              slot1: value.opinion ? this.$t('确认') : this.$t('拒绝'),
            })
          )
          this.getMettingList(this.newDay)
          this.showRepeat = false
          this.message = ''
        })
      }
    },
    async clickeRefuse() {
      if (!this.message && !this.ifAgree) {
        return
      }
      let staffId = this.user.id
      let value = {
        appointmentRecordId: this.refuseData.relationId,
        staffId,
        opinion: false,
        calendarId: this.refuseData.id,
      }

      await saveMeetingMessage({
        staffId,
        remark: this.message,
        meetingId: this.refuseData.relationId,
        agree: 0,
        // calendarId: this.refuseData.id
      })
      const res = await refuseMeeting(value)
      Toast(this.$t('会议已拒绝！'))
      this.getMettingList(this.newDay)
    },
    checkRemark(action, done) {
      if (action === 'confirm') {
        if (!this.message && !this.ifAgree) {
          done(false)
        } else {
          done()
        }
      } else {
        done()
        this.message = ''
      }
    },
    async queryUserPermission(staffId) {
      this.isLoading = true
      try {
        const response = await getRole({ staffId })
        this.menuPermissions = response.menuPermissions.filter(
          (v) => v.pid === 0
        )
        this.isLoading = false
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onRefuseRe(data) {
      this.choseData = data
      this.showRefuseRe = true
      this.refuseMessage = ''
    },
    onOk(data) {
      this.choseData = data
      this.showOk = true
      this.meetingRoomName = data.meetingRoomName
      this.areaid = data.meetingRoomId
      let index = this.areaList.findIndex((item) => {
        return item.id === data.meetingRoomId
      })
      this.meetingChoseLevel = data.meetingLevel
      this.areaResult = [index]
    },
    onAllocation(data) {
      this.choseData = data
      this.showAllocation = true
      this.servicePeopelName = ''
      this.servicePeopelId = ''
      this.servicePersonnerlDpt = ''
    },
    onDone(data) {
      this.choseData = data
      this.showDone = true
    },
    onComment(data) {
      this.choseData = data
      this.showComment = true
      this.commentValue = 0
    },
    clickOkClose() {
      this.choseData = {}
      this.showOk = false
    },
    clickRefuseClose() {
      this.choseData = {}
      this.showRefuseRe = false
    },
    clickAllocationClose() {
      this.choseData = {}
      this.showAllocation = false
    },
    clickDoneClose() {
      this.choseData = {}
      this.showDone = false
    },
    clickCommentClose() {
      this.choseData = {}
      this.showComment = false
    },
    cilkcshowServicePeopel() {
      this.showAllocation = false
      this.showServicePeopel = true
    },
    toMeetingInform() {
      if (this.areaResult.length == 0) {
        Toast.fail(this.$t('会议室不能为空'))
        return
      }
      let index = this.areaResult[0]
      this.meetingRoomName = this.areaList[index].name
      this.areaid = this.areaList[index].id
      this.showArea = false
    },
    async IsDoOk(flag, id) {
      this.showToast = false
      this.isUseDoOk = true
      let remark = {}
      if (
        this.meetingChoseLevel != this.choseData.meetingLevel ||
        this.areaid != this.choseData.meetingRoomId
      ) {
        remark = {
          meetingRoomName: this.meetingRoomName,
          meetingLevel: this.meetingChoseLevel,
        }
      }
      try {
        await processingData({
          approverId: this.user.id,
          companyId: this.user.companyId,
          id: this.choseData.id,
          meetingLevel: this.meetingChoseLevel,
          meetingRoomId: this.areaid,
          state: 'APPROVED',
          remark:
            JSON.stringify(remark) === '{}'
              ? undefined
              : JSON.stringify(remark),
          openMeetingService:
            this.areaid != this.choseData.meetingRoomId
              ? flag
                ? flag
                : false
              : undefined,
          meetingManger: id ? id : undefined,
        })
        this.choseData = {}
        this.geth5MeetingServiceRecord()
        this.showOk = false
        this.isUseDoOk = false
        Toast(this.$t('已同意'))
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.choseData = {}
        this.showOk = false
        this.isUseDoOk = false
      }
    },
    async doOk() {
      if (
        this.areaid != this.choseData.meetingRoomId &&
        this.choseData.openMeetingService
      ) {
        getMeetingRoomById(this.areaid).then((res) => {
          if (res.openMeetingService && res.meetingManger) {
            this.IsDoOk(res.openMeetingService, res.meetingManger)
          } else {
            this.showToast = true
          }
        })
      } else {
        this.IsDoOk()
      }
    },
    async doRefuse() {
      try {
        this.isUseRefuse = true
        await processingData({
          approverId: this.user.id,
          companyId: this.user.companyId,
          id: this.choseData.id,
          remark: this.refuseMessage,
          state: 'REJECTED',
        })
        this.choseData = {}
        this.geth5MeetingServiceRecord()
        this.showRefuseRe = false
        this.isUseRefuse = false
        Toast(this.$t('已拒绝'))
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.choseData = {}
        this.showRefuseRe = false
        this.isUseRefuse = false
      }
    },
    async doAllocation() {
      if (this.servicePeopelId) {
        try {
          this.isUseAllocation = true
          await assignPersonnel({
            staffId: this.user.id,
            servicePersonnerl: this.servicePeopelId,
            servicePersonnerlDpt: this.servicePersonnerlDpt,
            todoId: this.choseData.id,
          })
          this.choseData = {}
          this.geth5MeetingServiceRecord()
          this.showAllocation = false
          this.isUseAllocation = false
          Toast(this.$t('已完成分配'))
        } catch (error) {
          Toast.fail(error.response.data)
        } finally {
          this.choseData = {}
          this.showAllocation = false
          this.isUseAllocation = false
        }
      } else {
        return
      }
    },
    async doDone() {
      try {
        this.isUseDone = true
        await serviceComplete({
          staffId: this.user.id,
          todoId: this.choseData.id,
        })
        this.choseData = {}
        Toast(this.$t('已完成'))
        this.geth5MeetingServiceRecord()
        this.showDone = false
        this.isUseDone = false
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.choseData = {}
        this.showDone = false
        this.isUseDone = false
      }
    },
    async doComment() {
      if (this.commentValue < 1) {
        return
      } else {
        try {
          this.isUseComment = true
          await submitterGrade({
            score: this.commentValue,
            todoId: this.choseData.id,
          })
          this.choseData = {}
          Toast(this.$t('已完成点评'))
          this.geth5MeetingServiceRecord()
          this.showComment = false
          this.isUseComment = false
        } catch (error) {
          Toast.fail(error.response.data)
        } finally {
          this.choseData = {}
          this.showComment = false
          this.isUseComment = false
        }
      }
    },
    toInform() {
      this.showServicePeopel = false
      this.showAllocation = true
    },
    confirmSearch(data) {
      let people = data[0]
      let departmentId = people?.departmentId?.split(',')[0]
      this.servicePeopelName = people.name
      this.servicePeopelId = people.id
      this.servicePersonnerlDpt = people.id + '-' + departmentId
      this.showServicePeopel = false
      this.showAllocation = true
    },
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    // this.ifShow(this.user.id)
    this.getOffline(this.user.companyId)
    this.getMettingList(1)
    this.geth5MeetingServiceRecord()
    this.getBanners(this.user.companyId)
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
    this.queryUserPermission(this.user.id)
    this.getPermissions(this.user.companyId)
    this.offLine = false
    this.getAreaId(this.user.companyId)
    this.getUsers(this.user.companyId)
    // this.maxHeight = (window.innerHeight - 68) + 'px';
    // window.addEventListener('resize', this.handleResize);
  },
}
</script>
<style lang="less" scoped>
body {
  background: #edf0f6 !important;
}

.robot {
  // min-height: 100%;
  background: #edf0f6;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  // margin-bottom: constant(safe-area-inset-bottom);
  padding-bottom: calc(constant(safe-area-inset-bottom, 0px) + 68px);
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 68px);
  scrollbar-width: none;

  .content {
    padding: 20px 12px;

    // img {
    //   width: 359px;
    //   height: 136px;
    // }

    .dropdownImg {
      width: 20px;
      height: 20px;
    }

    .emptyImg {
      width: 128px;
      height: 97px;
      margin-bottom: 8px;
    }
  }
}

.robot::-webkit-scrollbar {
  display: none;
}

.navBar {
  background: #ffffff;
  line-height: 40px;
  text-align: center;
  font-size: 18px;

  // position: relative;
  .title {
    font-size: 17px;
    font-weight: 500;
    color: #333333;
  }
}

.button_box {
  display: flex;
  position: absolute;
  top: 65px;
  right: 0;
}

.webHeader {
  width: 100%;
  // height: 180px;

  .headerImg {
    width: 100%;
    // height: 180px;
  }

  .headerImgBlock {
    width: 100%;
    // height: 180px;
    display: flex;
    justify-content: center;
  }

  .headerImgCover {
    width: 100%;
    max-height: 180px;
    object-fit: contain;
  }
}

.tabLine {
  width: 100%;
  // height: 80px;
  // background: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  // border-radius: 5px;
  margin-bottom: 20px;
  gap: 8px;

  .tab {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin-top: 2px;

    .tabImg {
      width: 56px;
      height: 56px;
      margin-bottom: 8px;
    }

    .tabText {
      font-family: SourceHanSansSC, SourceHanSansSC;
      font-weight: 400;
      font-size: 14px;
      color: #1e2329;
      line-height: 20px;
      text-align: center;
    }
  }
}

.bigDataCard {
  width: '100%';
  // height: 144px;
  background: #ffffff;
  border-radius: 4px;
  margin-top: 12px;
  // padding: 0 6px;
}

.dataTitle {
  width: '100%';
  height: 36px;
  // padding: 0 6px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #eeeeee;

  .dataTitleC {
    width: 6px;
    height: 6px;
    background: #0082f7;
    border-radius: 3px;
    margin-left: 3px;
    margin-right: 6px;
  }

  .dataTitleText {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
}

.dataInfo {
  height: 83px;
  background: linear-gradient(180deg, #f1fbff 0%, #ffffff 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .hasLine {
    width: 1px;
    height: 36px;
    background: #eaecef;
  }

  .hasWarnStyle {
    display: flex;
    align-items: center;
  }

  .dataInfoThree {
    height: '100%';
    width: 118px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .dataInfoTwo {
    height: '100%';
    width: 179px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .dataNumber {
    font-family: Lato, Lato;
    font-weight: 800;
    font-size: 24px;
    line-height: 29px;
    margin-bottom: 4px;
  }

  .dataNumberName {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #707a8a;
    line-height: 20px;
  }

  .colorG {
    color: #0cd342;
  }

  .colorR {
    color: #ff2727;
  }

  .colorY {
    color: #faad14;
  }
}

.offLine {
  padding: 0 6px 16px;

  .hideLine {
    display: flex;
    justify-content: center;
    align-items: center;

    .hideLineIcon {
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      margin-right: 6px;
    }

    .hideLineText {
      margin-left: 5px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
    }
  }
}

.schedule {
  width: '100%';
  min-height: 150px;
  background: linear-gradient(180deg, #f1fbff 0%, #ffffff 100%);
  border-radius: 8px;
  padding: 12px 15px 14px 12px;
  position: relative;

  .scheduleHeader {
    height: 37px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .meetingStatus {
    width: 58px;
    height: 22px;
    // background: rgba(196, 231, 255, 0.5);
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 4px;
    // margin-top: -2px;
  }

  .meetingStatusColor {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    // color: #3972FF;
  }

  .scheduleHeaderLeft {
    // height: 24px;
    display: flex;
    align-items: center;
    // margin-top: 2px;

    .scheduleHeaderC {
      width: 6px;
      height: 6px;
      background: #0082f7;
      border-radius: 3px;
      margin-right: 6px;
      margin-top: 1px;
    }
  }

  .scheduleHeaderName {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    margin-right: 12px;
    margin-top: 1px;
  }

  .scheduleHeaderTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 158px;
    height: 36px;
    background: #eaecef;
    border-radius: 8px;
    padding: 3px 2px;
  }

  .scheduleHeaderTitleOther {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 158px;
    height: 36px;
    padding: 3px 2px;
  }

  .scheduleHeaderTitleBottom {
    width: 24px;
    height: 3px;
    background: #3972ff;
    position: absolute;
    left: 26px;
    bottom: -6px;
  }

  .scheduleTopHeaderLine {
    position: absolute;
    width: 100%;
    border-top: 1px solid #eaecef;
    top: 95px;
    left: 0;
    z-index: 1;
  }

  .scheduleTopHeader {
    // display: flex;
    // justify-content: center;
    // align-items: center;
    position: relative;
    z-index: 2;
    width: 158px;
    height: 42px;
    // background: #eaecef;
    // border-radius: 8px;
    // padding: 3px 2px;
    margin-top: 8px;
  }

  .clickLeftButton {
    width: 76px;
    height: 30px;
    background: #ffffff;
    border-radius: 6px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #3972ff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .notClickLeftButton {
    width: 76px;
    height: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #474d57;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .clickLeftText {
    position: relative;
    width: 76px;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #3972ff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .notClickLeftText {
    width: 76px;
    height: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #474d57;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .scheduleHeaderRight {
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;

    .scheduleHeaderRightBotton {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #3972ff;
    }
  }
}

.hideOverdueCard {
  width: '100%';
  height: 20px;
  // background: #f7f7f7;
  border-radius: 4px 4px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

.overdueLine {
  width: '100%';
  // background: #f7f7f7;
  border-radius: 4px;
  margin-top: 8px;

  .overdueD {
    width: '100%';
    // border-bottom: 1px solid #eeeeee;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .overdueName {
      width: 320px;
      -o-text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      line-clamp: 2;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #b7bdc6;
      // opacity: 0.4;
    }

    .overdueOther {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;

      .overdueImg {
        width: 16px;
        height: 16px;
        // opacity: 0.4;
        margin-right: 6px;
      }

      .overdueOtherName {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #b7bdc6;
        // margin-top: 2px;
      }
    }
  }
}

.hideOverdueLine {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px;
  width: '100%';
}

.orderListD {
  width: '100%';
  // height: 103px;
  border-bottom: 1px solid #eaecef;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  .orderListName {
    width: 320px;
    -o-text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    line-clamp: 2;
    white-space: normal;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1e2329;
  }

  .orderListOther {
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-top: 8px;
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // -o-text-overflow: ellipsis;

    .orderListImg {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
}

.orderListM {
  width: '100%';
  // height: 103px;
  border-top: 1px solid #eeeeee;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  .orderListName {
    width: 320px;
    -o-text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    line-clamp: 2;
    white-space: normal;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1e2329;
  }

  .orderListOther {
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-top: 10px;
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // -o-text-overflow: ellipsis;

    .orderListImg {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }

    .orderListOtherName {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #474d57;
      width: 220px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  }
}

.orderListB {
  width: '100%';
  // height: 103px;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  .orderListName {
    width: 320px;
    -o-text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    line-clamp: 2;
    white-space: normal;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1e2329;
  }

  .orderListOther {
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-top: 10px;

    .orderListImg {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
}

.orderListOtherName {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #474d57;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.orderListOtherNameShort {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #474d57;
  width: 160px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.orderSevenListB {
  width: '100%';
}

.orderListTite {
  height: 40px;
  width: 100%;
  // border-top: 1px solid #eeeeee;
  padding: 0 10px;
}

.orderListTiteLine {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
}

.editDestine {
  width: 68px;
  height: 32px;
  background: #009bff;
  border-radius: 24px;
  font-family: PingFangSC, PingFang SC;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.orderListTitelName {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-right: 15px;
}

.orderListTitelLine {
  width: 185px;
  height: 0px;
  border-top: 1px solid;
  border-image: linear-gradient(270deg,
      rgba(246, 247, 248, 0.1),
      rgba(220, 226, 235, 1)) 1 1;
}

.card_button_reserve {
  width: 80px;
  height: 28px;
  background: #ffffff;
  border-radius: 15px;
  border: 1px solid #009bff;
  font-size: 14px;
  font-weight: 400;
  color: #009bff;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-right: 12px;
}

.operation {
  position: absolute;
  bottom: 20px;
  right: 4px;
  display: flex;
  align-items: center;

  .rejectDestine {
    width: 68px;
    height: 32px;
    background: #ffffff;
    border-radius: 15px;
    border: 1px solid #ffa39e;
    font-family: PingFangSC, PingFang SC;
    font-size: 14px;
    font-weight: 400;
    color: #ff4d4f;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
  }
}

/deep/.van-cell::after {
  border: none;
}

/deep/.outsiderStyle {
  width: 296px;

  .outsider-title {
    font-size: 18px;
    line-height: 24px;
  }

  .van-cell::after {
    border: none;
  }

  .van-dialog__header {
    padding: 32px 0px 13px;
  }

  .cancel-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 0 0 20px 49px;

    .first-cancel {
      margin-bottom: 7px;
    }
  }

  .refuse-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 10px 0 41px;
    display: flex;
    justify-content: center;
  }

  .van-field__label {
    margin-left: 19px;
    width: 29px;
    line-height: 36px;
    font-size: 14px;
    margin-right: 8px;
  }

  .outsider-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 36px;
    padding-left: 8px;
    width: 192px;
  }

  input::-webkit-input-placeholder {
    color: #cfcfcf;
  }

  input::-moz-placeholder {
    color: #cfcfcf;
  }

  input:-moz-placeholder {
    color: #cfcfcf;
  }

  input:-ms-input-placeholder {
    color: #cfcfcf;
  }
}

.repeat-title {
  margin-top: -8px;
}

.repeat-box {
  margin-top: -5px;

  .repeat-tip {
    padding: 0 26px;
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    margin-bottom: 16px;
  }
}

.repeat-info {
  padding-left: 21px;
  padding-right: 21px;
  font-size: 12px;
  color: #999999;
  line-height: 24px;

  .repeat-info-box {
    display: flex;
    justify-content: space-between;
  }
}

.remark-box {
  width: 224px;
  min-height: 80px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.margin8 {
  margin: 0 auto 8px;
}

.margin-repaet {
  margin: 8px auto 16px;
}

.cancelDestine {
  // width: 64px;
  // height: 28px;
  // border-radius: 24px;
  // border: 1px solid #009bff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3972ff;
}

.scheduleDestine {
  width: 68px;
  height: 32px;
  border-radius: 24px;
  border: 1px solid #009bff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3972ff;
}

.scheduleRejection {
  width: 68px;
  height: 32px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid #ffa39e;
  color: #ff4d4f;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.scheduleHeaderRightLine {
  width: 1px;
  height: 12px;
  background-color: #b7bdc6;
  margin-left: 10px;
  margin-right: 10px;
}

.dropdownLine {
  width: 136px;
  height: 1px;
  background-color: #eaecef;
}

/deep/.van-popup {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}

.offLineTitle {
  width: 100%;
  height: 56px;
  background-color: #f2f4f7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #1e2329;
}

.offLineD {
  width: 100%;
  height: 502px;
  background: #ffffff;
  overflow: hidden;
  overflow-y: auto;
  scrollbar-width: none;
}

.offLineD::-webkit-scrollbar {
  display: none;
}

.offLineItem {
  width: 100%;
  height: 72px;
  padding: 12px;
  border-bottom: 1px solid #eeeeee;
  background: #ffffff;
}

.offLineName {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.offLineNameDot {
  width: 6px;
  height: 6px;
  background: #f6465d;
  margin-right: 6px;
  border-radius: 50%;
}

.offLineNameText {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1e2329;
  width: 320px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.offLineTime {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #707a8a;
  margin-left: 12px;
}

.emptyStyle {
  width: 100%;
  height: 176px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 9px;
}

.emptyText {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #646b73;
  line-height: 20px;
}

.emptyOffLine {
  width: 100%;
  height: 486px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.emptyOffLineImg {
  width: 214px;
  height: 160px;
  margin-bottom: 16px;
}

.representativeListB {
  width: '100%';
  // height: 103px;
  padding: 20px 10px;
}

.representativeListBBlock {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

.representativeListD {
  width: '100%';
  // height: 103px;
  border-bottom: 1px solid #eaecef;
  padding: 20px 10px;
}

.representativeListDBlock {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

.representativeListName {
  width: 320px;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  line-clamp: 2;
  white-space: normal;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #1e2329;
  margin-bottom: 4px;
}

.representativeOther {
  display: flex;
  // justify-content: center;
  align-items: center;
  margin-top: 10px;

  .overepresentativeImg {
    width: 16px;
    height: 16px;
    // opacity: 0.4;
    margin-right: 6px;
  }

  .representativeOtherName {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #b7bdc6;
    // margin-top: 2px;
  }

  .representativeName {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #474d57;
    width: 288px;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    // margin-top: 2px;
  }
}

.representativeTime {
  display: flex;
  // justify-content: center;
  align-items: flex-start;
  margin-top: 10px;

  .overepresentativeImg {
    width: 16px;
    height: 16px;
    // opacity: 0.4;
    margin-right: 6px;
  }

  .representativeOtherTime {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #474d57;
    width: 288px;
    word-break: break-all;
    /* 任意位置都可以断行 */
    /* 或 */
    word-break: break-word;
    /* 类似 overflow-wrap: break-word */
  }
}

.operationRe {
  // padding: 0 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 14px;

  .okButton {
    width: 147px;
    height: 32px;
    border-radius: 18px;
    border: 1px solid #3972ff;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #3972ff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .refuseButton {
    width: 147px;
    height: 32px;
    border-radius: 16px;
    border: 1px solid #f6465d;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #f6465d;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
  }

  .allocationBotton {
    width: 307px;
    height: 32px;
    border-radius: 18px;
    border: 1px solid #3972ff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 9px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #3972ff;
  }
}

/deep/.van-popup {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background-color: #f2f4f7;
}

.popupStyle {
  height: 362px;
  width: 100%;
  padding: 8px 12px 14px;
}

.popupHeader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 56px;
  margin-bottom: 12px;
  position: relative;
}

.popupClose {
  position: absolute;
  left: 12px;
  top: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #1e2329;
}

.popupTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #1e2329;
}

.bookBox {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 38px;
}

.bookBoxAllocation {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 154px;
}

.bookBoxOk {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.popupText {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #474d57;
  padding-left: 11px;
  margin-bottom: 200px;
}

.danger-btn {
  width: 351px;
  height: 46px;
  background: #ff4d4f;
  border-radius: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.blue-btn {
  width: 351px;
  height: 46px;
  background: #3972ff;
  border-radius: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.grey-btn {
  width: 351px;
  height: 46px;
  background: rgba(183, 189, 198, 0.6);
  border-radius: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.popupBlock {
  width: 351px;
  height: 72px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
  margin-bottom: 12px;
}

.popupOk {
  width: 351px;
  height: 72px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  // justify-content: center;
  align-items: center;
  padding-left: 24px;
  // margin-bottom: 12px;
}

.popupOkOther {
  width: 351px;
  height: 92px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 24px;
  // margin-bottom: 12px;
}

.popupComment {
  width: 351px;
  height: 72px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  // justify-content: center;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 146px;
}

.commentStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #474d57;
}

.timeListTitle {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 20px;
}

.timeList {
  position: relative;
  height: 424px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 16px;
  overflow-y: auto;
  overflow-x: hidden;

  .timeListCard {
    height: 52px;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .timeListRange {
    display: block;
    border-bottom: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    height: 52px;
    width: 375px;
    line-height: 51px;

    .extra {
      padding-left: 24px;
    }
  }
}

.dropdownImgOther {
  width: 20px;
  height: 20px;
  transform: rotate(270deg);
}

.okTextStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #1e2329;
}

.okTextGreyStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #b7bdc6;
}
</style>
